// Custom Dashboard 2 MUI Base Styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";

// Soft UI Dashboard PRO helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { inputColors } = colors;
const { borderWidth, borderRadius } = borders;

const input = {
  styleOverrides: {
    root: {
      display: "flex !important",
      padding: `${pxToRem(8)} ${pxToRem(12)}`,
      border: `${borderWidth[1]} solid ${inputColors.borderColor.main}`,
      borderRadius: `${borderRadius.md} !important`,

      "& fieldset": {
        border: "none",
      },

      "&:focus-within": {
        border: `${borderWidth[1]} solid ${inputColors.borderColor.main}`,
        boxShadow: "none",
      },
    },

    input: {
      height: pxToRem(22),
      width: "100% !important",
    },

    inputSizeSmall: {
      height: pxToRem(14),
    },
  },
};

export default input;
